export const PRIVACY_NOTICE_VERSION = "2026-05-11.v1";

export const CONSENT_VERSIONS = {
  privacyAcknowledgement: "2026-05-11.v1",
  futureRecruitment: "2026-05-11.v1",
  marketing: "2026-05-11.v1",
} as const;

// Data retention configuration (informational + future automation hook).
export const RETENTION = {
  candidateCurrentRecruitment: "[UZUPEŁNIJ - np. 6 miesięcy od zakończenia rekrutacji]",
  candidateFutureRecruitment: "[UZUPEŁNIJ - np. 24 miesiące od udzielenia zgody]",
  clientLead: "[UZUPEŁNIJ - np. 24 miesiące od ostatniego kontaktu]",
  cvAttachments: "[UZUPEŁNIJ - np. tożsamy z retencją zgłoszenia kandydata]",
} as const;

// Privacy notice (layered) - short summary + full breakdown.
export const PRIVACY_NOTICE = {
  controller:
    "Positive Recruitment Spółka z ograniczoną odpowiedzialnością (NIP: 6772472995, KRS: 0000945611, REGON: 520908168)",
  controllerContact:
    "ul. Juliusza Lea 100/21, 30-058 Kraków, Polska · e-mail: office@positiverecruitment.io",
  dpoContact:
    "Administrator nie wyznaczył Inspektora Ochrony Danych. W sprawach dotyczących przetwarzania danych osobowych prosimy o kontakt bezpośrednio z Administratorem: rodo@positiverecruitment.io",
  dataRequestsContact: "rodo@positiverecruitment.io",
  privacyPolicyUrl: "https://positiverecruitment.io/polityka-prywatnosci",
  cookiesPolicyUrl: "https://positiverecruitment.io/polityka-cookies",
  purposes: {
    candidate:
      "Prowadzenie obecnego procesu rekrutacyjnego, kontakt zwrotny i ocena kompetencji kandydata.",
    client:
      "Odpowiedź na zapytanie, przygotowanie oferty współpracy oraz realizacja usług rekrutacyjnych.",
  },
  legalBases: {
    candidate:
      "Art. 6 ust. 1 lit. a) RODO (zgoda) oraz, w zakresie wymaganym, art. 22(1) Kodeksu pracy.",
    client: "Art. 6 ust. 1 lit. a) i b) RODO (zgoda oraz działania zmierzające do zawarcia umowy).",
    futureRecruitment: "Art. 6 ust. 1 lit. a) RODO (zgoda).",
    marketing: "Art. 6 ust. 1 lit. a) RODO (zgoda).",
  },
  recipients:
    "Dostawcy usług IT i hostingu, dostawcy poczty elektronicznej oraz systemów ATS/CRM, podmioty współpracujące z Administratorem na podstawie umów powierzenia przetwarzania danych.",
  transfersOutsideEEA:
    "Dane co do zasady nie są przekazywane poza Europejski Obszar Gospodarczy. Jeżeli takie przekazanie wystąpi, odbędzie się na podstawie standardowych klauzul umownych zatwierdzonych przez Komisję Europejską.",
  rights:
    "Masz prawo dostępu do danych, sprostowania, usunięcia, ograniczenia przetwarzania, sprzeciwu, przenoszenia danych oraz - gdy przetwarzanie opiera się na zgodzie - wycofania zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania sprzed wycofania.",
  complaintAuthority:
    "Przysługuje Ci prawo wniesienia skargi do organu nadzorczego - Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa, https://uodo.gov.pl).",
  voluntariness:
    "Podanie danych jest dobrowolne, ale niezbędne do obsługi zgłoszenia. Brak podania danych oznaczonych jako wymagane uniemożliwi udzielenie odpowiedzi.",
  automatedDecisionMaking:
    "Nie podejmujemy wobec Ciebie zautomatyzowanych decyzji wywołujących skutki prawne, w tym profilowania w rozumieniu art. 22 RODO.",
} as const;

// Email routing for backend / Edge Functions integration.
export const EMAIL_CONFIG = {
  from: "noreply@positiverecruitment.io",
  replyTo: "office@positiverecruitment.io",
  adminNotification: [
    "office@positiverecruitment.io",
    "wojtek@positiverecruitment.io",
    "adrian@positiverecruitment.io",
  ] as const,
  rodoContact: "rodo@positiverecruitment.io",
} as const;

// File upload constraints for CV attachments (candidate path).
export const CV_UPLOAD = {
  enabled: true,
  maxSizeMB: 5,
  acceptedMime: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  acceptedLabel: "PDF, DOC, DOCX",
} as const;

// Endpoint stub - wire up to your backend / CRM / ATS / webhook before launch.
export const FORM_ENDPOINT: string | null = null;
export const FORM_ID = "prec-contact-form";
